<template>
    <input class="currency-field" 
           :required="required" 
           :type="inputType" 
           pattern="^\$(?!0\.00)([0-9,\.]+)$"
           v-model="inputValue"
           @focus="focus"
           @blur="blur"
           @input="update"
           placeholder="$"
           >
</template>
<script>

const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})

export default {
    name: 'currency-input',
    props: ['value', 'required','min', 'max'],
    data() {
        return {
            inputValue: '',
            inputType: 'text',
            isInput: false,
        }
    },
    computed: {
    },
    watch: {
        value (val, old) {
            if (val === undefined) return;

            if (!this.isInput) {
                this.inputValue = formatter.format(this.clamp(val))
            }
            this.isInput = false
        },
    },
    methods: {
        clamp(v) {
            let val = v;
            if (Number(v) > Number(this.max)) {
                val = this.max
            }
            else if (Number(v) < Number(this.min)) {
                val = this.min
            }

            return val
        },
        focus() {
            this.inputValue = this.clamp(this.inputValue.replace(/[^\d\.]+/ig, ''))
            this.inputType = 'number'
        },
        blur() {
            this.inputType = 'text'
            let val = this.clamp(this.inputValue.replace(/[^\d\.]+/ig, ''))
            let lastdot = val.lastIndexOf('.')

            val = val.replace('.', (m, offset, string) => {
                if (offset != lastdot) {
                    return ''
                }

                return '.'
            })

            this.inputValue = formatter.format(val)
            this.$emit('input', val)
        },
        update() {
            this.isInput = true
            let val = this.clamp(this.inputValue.replace(/[^\d\.]+/ig, ''))
            this.$emit('input', val)
        },
        isValid() {
            return this.inputValue && Number(this.inputValue) > 0
        },
    },
    mounted() {
        if (this.value) {
            this.inputValue = formatter.format(this.value)
        }
    }
}

</script>
<style lang="scss">
input.currency-field::-ms-clear {
    display: none;
}
input.currency-field {
    appearance: none;
}
</style>
